import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
  FaChevronRight,
} from "react-icons/fa";

import "./Footer.css";
import { BASE_URL } from "../../Config/config";

export default function Footer() {
  /* =====================================================
     CONTACT DATA
  ===================================================== */

  const [contactData, setContactData] = useState({
    phone: "",
    email: "",
    address: "",
    businessHours: "",
  });

  const [contactLoading, setContactLoading] = useState(true);

  /* =====================================================
     FETCH CONTACT DETAILS
  ===================================================== */

  useEffect(() => {
    const fetchContactDetails = async () => {
      try {
        setContactLoading(true);

        const response = await fetch(`${BASE_URL}/contact.php?action=get`);

        if (!response.ok) {
          throw new Error(`Contact API returned ${response.status}`);
        }

        const text = await response.text();

        console.log("CONTACT RAW RESPONSE:", text);

        let result;

        try {
          result = JSON.parse(text);
        } catch (error) {
          console.error("Invalid Contact API Response:", text);

          return;
        }

        console.log("CONTACT API RESPONSE:", result);

        /*
         * Support both:
         *
         * {
         *   status: true,
         *   data: {...}
         * }
         *
         * and:
         *
         * {
         *   phone: "...",
         *   email: "...",
         *   address: "..."
         * }
         */

        let data = result.data || result;

        /*
         * If backend returns:
         *
         * data: [ {...} ]
         *
         * take first record.
         */

        if (Array.isArray(data)) {
          data = data[0] || {};
        }

        console.log("CONTACT DATA USED:", data);

        setContactData({
          phone: data.phone || data.phone_number || data.mobile || "",

          email: data.email || data.email_address || "",

          address: data.address || data.office_address || "",

          businessHours:
            data.businessHours ||
            data.business_hours ||
            data.business_hours_text ||
            "",
        });
      } catch (error) {
        console.error("Fetch Contact Details Error:", error);
      } finally {
        setContactLoading(false);
      }
    };

    fetchContactDetails();
  }, []);

  /* =====================================================
     PHONE LINK
  ===================================================== */

  const phoneLink = contactData.phone
    ? `tel:${contactData.phone.replace(/\D/g, "")}`
    : "#";

  /* =====================================================
     EMAIL LINK
  ===================================================== */

  const emailLink = contactData.email ? `mailto:${contactData.email}` : "#";

  return (
    <footer className="site-footer">
      {/* =====================================================
          CTA
      ===================================================== */}

      <div className="footer-cta">
        <div className="footer-container footer-cta-inner">
          <div className="footer-cta-content">
            <span>READY TO GROW YOUR BUSINESS?</span>

            <h2>Let's Build a Smarter Business Together</h2>

            <p>
              Get the right software solution, expert support and technology
              guidance for your business.
            </p>
          </div>

          <Link to="/contact" className="footer-cta-button">
            Get Started
            <FaArrowRight />
          </Link>
        </div>
      </div>

      {/* =====================================================
          MAIN FOOTER
      ===================================================== */}

      <div className="footer-main">
        <div className="footer-container footer-grid">
          {/* =================================================
              COMPANY
          ================================================= */}

          <div className="footer-company">
            <Link to="/home" className="footer-logo">
              <img
                src="/favicon.ico"
                alt="Star Computers & Information Technology"
                className="logo"
              />

              <div>
                <strong>Star Computers & Information Technology</strong>

                <span>Best Service , Right Time , Right People</span>
              </div>
            </Link>

            <p>
              Star Computers provides reliable Tally, ERP, HRMS, accounting and
              custom software solutions to help businesses work smarter and grow
              faster.
            </p>

            <div className="footer-social">
              <a href="#facebook" aria-label="Facebook">
                <FaFacebookF />
              </a>

              <a href="#instagram" aria-label="Instagram">
                <FaInstagram />
              </a>

              <a href="#linkedin" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>

              <a href="#youtube" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* =================================================
              QUICK LINKS
          ================================================= */}

          <div className="footer-column">
            <h3>Quick Links</h3>

            <ul>
              <li>
                <Link to="/home">
                  <FaChevronRight />
                  Home
                </Link>
              </li>

              <li>
                <Link to="/about">
                  <FaChevronRight />
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/products">
                  <FaChevronRight />
                  Our Solutions
                </Link>
              </li>

              <li>
                <Link to="/gallery">
                  <FaChevronRight />
                  Gallery
                </Link>
              </li>

              <li>
                <Link to="/contact">
                  <FaChevronRight />
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* =================================================
              PRODUCTS
          ================================================= */}

          <div className="footer-column">
            <h3>Our Solutions</h3>

            <ul>
              <li>
                <Link to="/products/tally-prime">
                  <FaChevronRight />
                  TallyPrime
                </Link>
              </li>

              <li>
                <Link to="/products/miracle">
                  <FaChevronRight />
                  Miracle
                </Link>
              </li>

              <li>
                <Link to="/products/busy">
                  <FaChevronRight />
                  BUSY
                </Link>
              </li>

              <li>
                <Link to="/products/odoo-erp">
                  <FaChevronRight />
                  Odoo ERP
                </Link>
              </li>

              <li>
                <Link to="/products/ottu-hrms">
                  <FaChevronRight />
                  Ottu HRMS
                </Link>
              </li>

              <li>
                <Link to="/modules">
                  <FaChevronRight />
                  Tally Modules
                </Link>
              </li>
            </ul>
          </div>

          {/* =================================================
              CONTACT
          ================================================= */}

          <div className="footer-column footer-contact">
            <h3>Contact Us</h3>

            {/* PHONE */}

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <FaPhoneAlt />
              </div>

              <div>
                <span>Call Us</span>

                {contactLoading ? (
                  <span>Loading...</span>
                ) : contactData.phone ? (
                  <a href={phoneLink}>{contactData.phone}</a>
                ) : (
                  <span>Phone not available</span>
                )}
              </div>
            </div>

            {/* EMAIL */}

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <FaEnvelope />
              </div>

              <div>
                <span>Email Us</span>

                {contactLoading ? (
                  <span>Loading...</span>
                ) : contactData.email ? (
                  <a href={emailLink}>{contactData.email}</a>
                ) : (
                  <span>Email not available</span>
                )}
              </div>
            </div>

            {/* ADDRESS */}

            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <FaMapMarkerAlt />
              </div>

              <div>
                <span>Visit Us</span>

                {contactLoading ? (
                  <p>Loading...</p>
                ) : contactData.address ? (
                  <p>{contactData.address}</p>
                ) : (
                  <p>Address not available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =====================================================
          BOTTOM FOOTER
      ===================================================== */}

      <div className="footer-bottom">
        <div className="footer-container footer-bottom-inner">
          <p>
            © {new Date().getFullYear()} <strong>Star Computers</strong>. All
            Rights Reserved.
          </p>

          {/* <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>

            <span>|</span>

            <Link to="/terms">Terms & Conditions</Link>
          </div> */}

          <p className="footer-developed">
            Designed & Developed by{" "}
            <a
              href="https://lifetimeinfotech.in"
              target="_blank"
              rel="noopener noreferrer"
              className="lifetime-link"
            >
              <strong>Lifetime Infotech</strong>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
